
/* eslint-disable */
import { ArtistTrackModel } from '@/models'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class GenreTracks extends Vue {
    loader = true
    sourceTracks: ArtistTrackModel[] = []
    pictures = [
        'https://i.pinimg.com/564x/54/2c/7f/542c7feaddcbf4abe9a44146303b1cad.jpg',
        'https://i.pinimg.com/564x/8f/7f/53/8f7f5348d3ef93db0186c8f70f313382.jpg',
        'https://i.pinimg.com/564x/02/27/d6/0227d60b428325a9965f992aef89e96e.jpg',
        'https://i.pinimg.com/564x/f6/6e/ef/f66eef74cad510e4a5c3189987d632ac.jpg',
        'https://i.pinimg.com/564x/49/09/bd/4909bd32abbd4a9883102a42ef204bcc.jpg',
        'https://i.pinimg.com/564x/55/e9/4d/55e94d02f739e1cccd3c0e657e6741ea.jpg',
        'https://i.pinimg.com/564x/19/41/d5/1941d5cbcb64e4e8009b323182fccda3.jpg',
        'https://i.pinimg.com/564x/2a/6f/11/2a6f11188cf7c5d508440d62337975cf.jpg',
        'https://i.pinimg.com/564x/8f/77/ee/8f77ee365975dcd81c42686c5cc39d36.jpg',
        'https://i.pinimg.com/564x/f1/ea/52/f1ea5220fce6029be4fbebb8d15e7446.jpg',
        'https://i.pinimg.com/564x/4a/ea/dc/4aeadc839682e100b33dd61daea9daf2.jpg',
        'https://i.pinimg.com/564x/e8/c9/96/e8c996faca963422e844a4b6ff5ef1be.jpg',
        'https://i.pinimg.com/564x/2e/f4/8c/2ef48c968657f859a40f3973da74f071.jpg',
        'https://i.pinimg.com/564x/46/af/7d/46af7db4d3790c51c4d76b270a070406.jpg',
        'https://i.pinimg.com/564x/14/e5/dd/14e5dda26692163dfb47cff4c2f9a8cb.jpg'
    ]
    pageOffset = 0
    pageOffsetAlt = 0
    clicks = 1

    get radioSource() {
        return this.$store.getters['getRadioSource']
    }

    get isExternalSource() {
        return this.radioSource === 'audius' || this.radioSource === 'suno'
    }

    pageNext () {
        if (this.isExternalSource) return
        this.pageOffset += 16
        this.loader = true
        const obj = {
            genre: this.$route.params.link,
            offset: this.pageOffset
        }
        this.$store.dispatch('trackModule/fetchGenreTracks', obj).then(()=> {
            this.loader = false
            window.scrollTo(0,0);
            this.clicks ++;
            this.pageOffsetAlt += 16
        })
    }
    pageBack () {
        if (this.isExternalSource) return
        this.loader = true
        this.pageOffset -= 16
        const obj = {
            genre: this.$route.params.link,
            offset: this.pageOffset
        }
        this.$store.dispatch('trackModule/fetchGenreTracks', obj).then(()=> {
            this.loader = false
            window.scrollTo(0,0);
            this.clicks --;
            this.pageOffsetAlt -= 16
        })
    }

    backgroundImage() {
        return this.pictures[Math.floor(Math.random()*this.pictures.length)]
    }

    get tracks () {
        if (this.isExternalSource) {
            return this.sourceTracks
        }
        return this.$store.getters['trackModule/getTracks']? this.$store.getters['trackModule/getTracks']: []
    }

    get audio () {
        return this.$store.getters['getAudio']
    }

    get current () {
        return this.$store.getters['getCurrent']
    }

    playAlbum(id: string) {
        this.$store.dispatch('trackModule/fetchAlbumTracks', id).then((response) => {
            response[0].tracks.map((track: ArtistTrackModel) => {
                track['artist_name'] = response[0].artist_name
                track.image = response[0].image
            })
            this.$store.commit('setTracksQueue', response[0].tracks)
            this.$store.commit('playTrack', response[0].tracks[0])
            this.audio.src = response[0].tracks[0].audio
            this.audio.play()
        })
    }

    convertTime (secs: number | string) {
        const totalSec = Math.floor(Number(secs) || 0);
        const min = Math.floor(totalSec / 60);
        const sec = totalSec % 60;
        const minute = (min < 10) ? "0" + min : min;
        const seconds = (sec < 10) ? "0" + sec : sec;
        return (minute + ':' + seconds);
    }

    playSong (track: ArtistTrackModel, queue: ArtistTrackModel[]) {
        this.audio.playbackRate = 1
        this.audio.src = track.audio
        this.$store.commit('setTracksQueue', queue)
        this.$store.commit('playTrack', track)
        this.audio.play();
    }

    async loadContent() {
        this.loader = true
        window.scrollTo(0,0);
        const genre = this.$route.params.link
        if (this.radioSource === 'audius') {
            this.sourceTracks = await this.$store.dispatch('audiusModule/fetchRadioTracks', {
                limit: 30,
                genre: genre
            })
        } else if (this.radioSource === 'suno') {
            this.sourceTracks = await this.$store.dispatch('sunoModule/fetchRadioTracks', {
                limit: 30,
                genre: genre
            })
        } else {
            await this.$store.dispatch('trackModule/fetchGenreTracks', {
                genre: genre,
                offset: 0
            })
        }
        this.loader = false
    }

    mounted () {
        this.loadContent()
        this.$store.watch(
            (state: any) => state.radioSource,
            () => {
                this.pageOffset = 0
                this.pageOffsetAlt = 0
                this.clicks = 1
                this.loadContent()
            }
        )
    }
}
